import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { finishLoad, initLoad } from '../../..';
import { IListSlice } from '../../../types';
import filterTasks from './filterTasks';
import loadFilters from './loadFilters';

export default function addTaskMonitorActions(
  builder: ActionReducerMapBuilder<IListSlice>,
) {
  builder.addCase(loadFilters.pending, (state, payload) => {
    initLoad(state, payload.meta.arg.fieldId);
  });
  builder.addCase(loadFilters.rejected, (_, payload) => {
    console.error(payload.error);
  });
  builder.addCase(loadFilters.fulfilled, (state, { payload, meta }) => {
    const newFilters = state.lists[meta.arg.fieldId].filters?.map((filter) => {
      if (filter.id === payload.newFilterId) {
        return {
          ...filter,
          deleteFiltersTimestamp: Date.now(),
          options: payload.newFilterOptions,
          currentValue: '',
        };
      }
      return filter;
    });
    state.lists[meta.arg.fieldId].filters = newFilters;
    finishLoad(state, meta.arg.fieldId, true, newFilters);
  });

  builder.addCase(filterTasks.fulfilled, (state, payload) => {
    state.lists[payload.meta.arg.listId].rows = payload.payload?.rows ?? [];
    state.lists[payload.meta.arg.listId].pageInfo = payload.payload.pageInfo;
    state.lists[payload.meta.arg.listId].filters = payload.payload.filters;
    state.lists[payload.meta.arg.listId].areAllFiltersApplied = true;
    if (payload.payload?.rows.length <= 0) {
      state.lists[payload.meta.arg.listId].customLabel =
        window.FINDER_NO_DATA ?? '';
    }

    finishLoad(
      state,
      payload.meta.arg.listId,
      true,
      payload.payload.filters ?? undefined,
    );
  });
  builder.addCase(filterTasks.rejected, (state, payload) => {
    console.error(payload.error);
    finishLoad(state, payload.meta.arg.listId);
  });
  builder.addCase(filterTasks.pending, (state, payload) => {
    initLoad(state, payload.meta.arg.listId);
  });
}
